import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { RestApi } from '../RestApi/restApi';


interface vaultObjecRelationshipinfo {
  duplicates: any;
  statusMessage: any,
  error: boolean,
  data: any,
  message:any,
  failedlist:any
}

@Injectable({
  providedIn: 'root'
})
export class VaultObjectRelationshipService {
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private restAPI: RestApi
  ) { }

  insertVaultObjectRelationship(vaultObject){
    return this.http.post<vaultObjecRelationshipinfo>(this.restAPI.INSERT_VAULT_OBJECT_RELATIONSHIP,JSON.stringify(vaultObject),{ headers: this.headers })
  }
  updateVaultObjectRelationship(vaultObject){
    return this.http.post<vaultObjecRelationshipinfo>(this.restAPI.UPDATE_VAULT_OBJECT_RELATIONSHIP,JSON.stringify(vaultObject),{ headers: this.headers })
  }
  retreiveVaultObjectRelationshipData(pageno,pageSize) {
    return this.http.get<vaultObjecRelationshipinfo>(this.restAPI.RETRIEVE_VAULT_OBJECT_RELATIONSHIP+ "?page="+pageno+"&size="+pageSize, { headers: this.headers })
  }
  deleteVaultObjectRelationshipData(id) {
    return this.http.get<vaultObjecRelationshipinfo>(this.restAPI.DELETE_VAULT_OBJECT_RELATIONSHIP+"/"+id, { headers: this.headers })
  }
  downloadVaultObjectRelationshipData() {
    return this.http.get<vaultObjecRelationshipinfo>(this.restAPI.DOWNLOAD_VAULT_OBJECT_RELATIONSHIP, { headers: this.headers })
  }
  getVaultObjectRelationshipList(pageno,pageSize){
    // this.spinner.start();
    this.retreiveVaultObjectRelationshipData(pageno,pageSize).subscribe(res=>{
      if(res.error==true){
        // this.spinner.stop();
        this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
      }else{
        return res
      }
    })
  }
  uploadFileForVaultObjectRelationship(tablename,dnsId,formData) {
    return this.http.post<vaultObjecRelationshipinfo>(this.restAPI.UPLOADFILEFORVAULTOBJECTRELATIONSHIP+"/"+tablename+"/"+dnsId, formData)
  }

  uploadFileForObjectmetadata(tablename,dnsName,data) {
    return this.http.post<vaultObjecRelationshipinfo>(this.restAPI.UPLOADFILEFOROBJECTMETADATA+"/"+tablename+"/"+dnsName,data)
  }
  uploadFileForAttributesMapping(mappingAttribute){
    return this.http.post<vaultObjecRelationshipinfo>(this.restAPI.UPLOADFILEFORATTRIBUTEMAPPING,mappingAttribute)
  }

  uploadFileForStageObjects(stagejson,tenantid){
    return this.http.post<vaultObjecRelationshipinfo>(this.restAPI.UPLLOADFILEFORSTAGEOBJECTS+"/"+tenantid,stagejson,{headers:this.headers})
    
  }
}
 